import { Navigate, useLocation } from 'react-router'

interface SettingsRedirectProps {
  /** The hub page that took over this route. */
  to: string
  /** Its section, when the old page became one (e.g. "phone"). */
  section?: string
}

/**
 * An old settings route that merged into the account hub. Keeps the query
 * (links from emails and the API carry ?redirect= and the like) and lands on
 * the section the old page became.
 */
export function SettingsRedirect({ to, section }: SettingsRedirectProps) {
  const { search, hash } = useLocation()
  const anchor = section ? `#${section}` : hash
  return <Navigate to={`${to}${search}${anchor}`} replace />
}
